import '@reach/dialog/styles.css';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import ButtonClose from '@remote-com/mushu/src/components/Ui/Button/ButtonClose';
import styled, { css } from 'styled-components';

import PlayIcon from '../images/play-video.svg';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const VideoOverlay = styled(DialogOverlay)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(23, 18, 55, 0.95);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 11;
`;

export const Content = styled(DialogContent)`
  outline: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  color: var(--colors-bayoux);
  --modalRadius: 10px;
  border-radius: var(--modalRadius);
  width: auto;
  align-items: center;
  justify-content: center;
  min-height: calc(100% - 100px);
  margin: 50px auto;

  && {
    width: 100%;
    background: transparent;
    margin: 0;
    padding: 0;
  }
`;

export const ButtonCloseStyled = styled(ButtonClose)`
  position: absolute;
  color: var(--colors-blank);
  top: 50px;
  right: 50px;
  border: 2px solid var(--colors-blank);
  border-radius: 50%;
  box-sizing: border-box;
`;

export const VideoContainer = styled.div`
  margin-top: 50px;
  width: 80%;
`;

export const StyledVideo = styled.video`
  max-width: 100%;
`;

export const PlayVideoIcon = styled(PlayIcon)`
  width: 52px;
  margin-right: 18px;
`;

export const PlayVideoButtonStyled = styled.button.attrs((props) => ({ type: 'button', ...props }))`
  color: #fff;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.2em;
  letter-spacing: 0.02em;
  outline: 0;
  padding: 0;
  background: none;
  border: none;

  ${PlayVideoIcon} {
    transition: transform 0.5s ease;
  }

  circle {
    transition: stroke 0.5s cubic-bezier(0.2, 1, 0.2, 1);
  }

  &:hover,
  &:focus {
    text-decoration: underline;

    ${PlayVideoIcon} {
      transform: scale(1.1);

      circle {
        stroke: #fff;
      }
    }
  }
`;

export const CtaContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${tabletBreakpoint(css`
    flex-direction: column;

    button {
      margin-left: 0;
    }
    * + * {
      margin-top: 32px;
    }
  `)}
`;
